import React from "react";
import { format } from "date-fns";
import s from "../StaffEmployeePersonal.less";

interface Position {
  instanceId: number;
  name: string;
  startDate: string | Date | undefined | null;
  moratoriumEndDate?: string | Date | undefined | null;
}

interface DateBlockMoratoriumIProps {
  positions?: Position[] | null;
}

const DateBlockMoratorium = ({ positions }: DateBlockMoratoriumIProps) => {
  const formatDate = (prop: string | Date | undefined | null): string => {
    if (!prop) {
      return "";
    }
    try {
      let upgrade = prop.toString().split("T")[0];
      let formatted = format(new Date(upgrade), "dd.MM.yyyy");
      return formatted;
    } catch (error) {
      return "";
    }
  };

  const startDates = positions
    ?.map((position) => formatDate(position.startDate))
    .filter((date) => date !== "")
    .join(", ");

  const moratoriumEndDates = positions
    ?.map((position) => formatDate(position.moratoriumEndDate))
    .filter((date) => date !== "")
    .join(", ");

  return (
    <div className={s.dateBlockMoratorium}>
      <div className={s.dateItem}>
        <span className={s.dateTitle}>
          Дата приказа назначения на должность
        </span>
        <span className={s.date}>{startDates || "—"}</span>
      </div>
      <div className={s.dateItem}>
        <span className={s.dateTitle}>Дата окончания моратория</span>
        <span className={s.date}>{moratoriumEndDates || "—"}</span>
      </div>
    </div>
  );
};

export default DateBlockMoratorium;
